export default __webpack_public_path__ + "static/media/navstep1-2.pic.c74ac889.jpg";